import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

import { StyledButton, PasswordFields } from '@selfserve/react-ui';
import { FormValues } from '../feature/set-password';

export interface Props {
  formik: FormikProps<FormValues>;
  isLoading: boolean;
}

export const SetPasswordForm = ({ formik, isLoading }: Props) => {
  const { t } = useTranslation();
  const { handleSubmit } = formik;
  return (
    <form onSubmit={handleSubmit}>
      <PasswordFields formik={formik} unbold autofocus hidePasswordError />
      <StyledButton
        type="submit"
        variant={isLoading ? 'select' : 'pill'}
        loading={isLoading}
        disabled={isLoading}
        fullWidth
      >
        {t('common.set-password')}
      </StyledButton>
    </form>
  );
};
